import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Check, X, ShieldCheck } from 'lucide-react';
import { DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Badge } from './ui/badge';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Readable per-user access profile: Module → ✓/✗ per action.
export const UserAccessProfile = ({ user }) => {
  const [catalog, setCatalog] = useState([]);
  useEffect(() => {
    axios.get(`${API_URL}/api/admin/permissions/catalog`).then((r) => setCatalog(r.data.catalog || r.data || [])).catch(() => {});
  }, []);
  const pv2 = user.permissions_v2 || {};
  const isSuper = user.role === 'super_admin';
  return (
    <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="access-profile-dialog">
      <DialogHeader>
        <DialogTitle className="font-heading flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-primary" /> Access Profile — {user.full_name}</DialogTitle>
        <DialogDescription>
          Role: <span className="font-medium capitalize">{(user.role || '').replace(/_/g, ' ')}</span>
          {user.department && <> · Department: {user.department}</>}
          {user.position && <> · {user.position}</>}
        </DialogDescription>
      </DialogHeader>
      {isSuper ? (
        <div className="p-4 bg-red-50 dark:bg-red-950/30 border border-red-200 rounded-md text-sm" data-testid="access-profile-super">
          Super Admin — unrestricted access to every module and action on the platform.
        </div>
      ) : (
        <div className="space-y-2">
          {catalog.map((m) => {
            const block = pv2[m.key] || {};
            const granted = (m.actions || []).filter((a) => block[a]);
            return (
              <div key={m.key} className="border rounded-md p-2.5" data-testid={`access-module-${m.key}`}>
                <div className="flex items-center justify-between mb-1.5">
                  <p className="text-sm font-medium">{m.label}</p>
                  <Badge variant="outline" className={granted.length === 0 ? 'bg-slate-100 text-slate-500' : granted.length === m.actions.length ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}>
                    {granted.length === 0 ? 'No access' : granted.length === m.actions.length ? 'Full access' : `${granted.length}/${m.actions.length}`}
                  </Badge>
                </div>
                <div className="flex flex-wrap gap-x-4 gap-y-1">
                  {(m.actions || []).map((a) => (
                    <span key={a} className={`inline-flex items-center gap-1 text-xs capitalize ${block[a] ? 'text-green-700 dark:text-green-400' : 'text-muted-foreground line-through'}`}>
                      {block[a] ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />} {a}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </DialogContent>
  );
};

export default UserAccessProfile;
